import React from 'react';
import { useFormContext } from 'react-hook-form';
import { BenefitType, Box, Notification, NotificationType } from 'edenred-ui';

import { Trans, useTranslation } from 'react-i18next';
import { PaymentMethods } from '@epi-constants/paymentMethods';
import { Payment, Schedule } from '@epi-constants/benefitTypes';
import { FormFields } from '@epi-forms/helpers';
import { IBenefits } from '@epi-models/containers/ManageBenefits';

interface TopupFormNotificationsProps {
  isLunchTopupRequest: boolean;
  benefitType?: IBenefits;
}

export const TopupFormNotifications = ({
  isLunchTopupRequest,
  benefitType
}: TopupFormNotificationsProps) => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  const paymentMethod = watch(FormFields.PaymentMethod);
  const scheduleType = watch(FormFields.ScheduleType);

  return (
    <>
      {paymentMethod === PaymentMethods.PdfInvoice && (
        <Box mt={2}>
          <Notification
            id="email-invoice-info"
            type={NotificationType.Important}
            text={t(
              'containers.deposit_money.topup_tab.form.payment.email_invoice_notification'
            )}
          />
        </Box>
      )}
      {!!benefitType &&
        !isLunchTopupRequest &&
        paymentMethod === Payment.EInvoice &&
        scheduleType === Schedule.Direct && (
          <Box mt={2}>
            <Notification
              type={NotificationType.Important}
              text={
                benefitType === BenefitType.lunch ? (
                  <Trans i18nKey="containers.deposit_money.topup_tab.form.payment.eInvoice_notification.lounari" />
                ) : (
                  <Trans i18nKey="containers.deposit_money.topup_tab.form.payment.eInvoice_notification.default" />
                )
              }
            />
          </Box>
        )}
    </>
  );
};
